<template>
    <biller-modal :isVisible="shouldShow">
        <div class="pt-24 px-16 md:px-24 pb-12 text-center modal-width">
            <p class="text-grey-300 text-base font-semibold">Payment is being Processed</p>
            <p class="text-grey-500 text-sm pt-2">We are checking the status of your transaction</p>
            <div class="my-12 relative h-48 flex items-center justify-center">
                <svg
                    width="120"
                    height="120"
                    viewBox="0 0 120 120"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="spin"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M60 111C88.2 111 111 88.2 111 60C111 31.8 88.2 9 60 9C31.8 9 9 31.8 9 60C9 88.2 31.8 111 60 111ZM60 120C93.1 120 120 93.1 120 60C120 26.9 93.1 0 60 0C26.9 0 0 26.9 0 60C0 93.1 26.9 120 60 120Z"
                        fill="#EFF2F7"
                    />
                    <path
                        d="M99.6001 27.9C104.3 33.6 107.7 40.4 109.5 47.8C110 49.8 111.8 51.3 113.9 51.3C116.8 51.3 119 48.6 118.3 45.8C116.2 37 112.1 29 106.6 22.2C105.7 21.1 104.4 20.5 103.1 20.5C99.2001 20.5 97.2001 24.9 99.6001 27.9Z"
                        fill="#3C1952"
                    />
                </svg>
            </div>
            <div class="flex items-center justify-center pt-10">
                <button class="rounded-lg bg-orange-pale px-8 py-4 text-orange font-semibold text-base">Go Back</button>
            </div>
        </div>
    </biller-modal>
</template>

<script>
export default {
    props: {
        shouldShow: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style scoped>
@keyframes spinner {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
.spin {
    animation: 1.5s linear infinite spinner;
    animation-play-state: inherit;
}

.modal-width {
    width: 450px;
}
</style>
